import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useMemo, useState } from "react";

type TAutoCompleteOption = {
	id: string;
	label: string;
};

interface IAutoCompletePermissionProps {
	options: TAutoCompleteOption[];
	isExternalLoading?: boolean;
	labelSelect?: string;
	disabled?: boolean;
}

export const AutoCompletePermission: React.FC<IAutoCompletePermissionProps> = ({
	options,
	isExternalLoading = false,
	labelSelect = "",
	disabled = false,
}) => {
	const { fieldName, registerField, defaultValue, error, clearError } = useField("permissionId");
	const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);
	const [inputValue, setInputValue] = useState("");

	useEffect(() => {
		registerField({
			name: fieldName,
			getValue: () => selectedId,
			setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
			clearValue: () => setSelectedId(undefined),
		});
	}, [fieldName, registerField, selectedId]);

	const autoCompleteSelectedOption = useMemo(() => {
		if (!selectedId) return null;
		return options.find((opcao) => opcao.id === selectedId) ?? null;
	}, [options, selectedId]);

	return (
		<Autocomplete
			openText="Abrir"
			closeText="Fechar"
			noOptionsText="Nenhuma opção"
			loadingText="Carregando..."
			disablePortal
			value={autoCompleteSelectedOption}
			options={options}
			size="small"
			fullWidth
			disabled={isExternalLoading || disabled}
			inputValue={inputValue}
			onInputChange={(_, newValue) => setInputValue(newValue)}
			onChange={(_, newValue) => {
				setSelectedId(newValue?.id);
				clearError();
			}}
			popupIcon={isExternalLoading ? <CircularProgress size={28} /> : undefined}
			renderInput={(params) => (
				<TextField
					{...params}
					label={labelSelect}
					error={!!error}
					helperText={error}
					disabled={disabled}
					fullWidth
				/>
			)}
		/>
	);
};
